import { Grid } from '../game/Grid';

export function getParticleColor(p: any): number {
    let c = p.color;
    let r = (c >> 16) & 0xFF;
    let g = (c >> 8) & 0xFF;
    let b = c & 0xFF;

    // 胶水效果：覆盖一层淡淡的青白色
    if (p.props.isGlued) {
        // 目标色：青白 (180, 255, 255)
        // 混合强度 0.3
        const glueFactor = 0.3;
        r = r + (180 - r) * glueFactor;
        g = g + (255 - g) * glueFactor;
        b = b + (255 - b) * glueFactor;
    }
    
    // 温度颜色混合逻辑
    // 高温：超过 200 度开始变红，到 800 度时达到最大热度颜色
    if (p.temperature > 200) {
        const maxHeatTemp = 600;
        const factor = Math.min(1, (p.temperature - 200) / maxHeatTemp);
        
        // 目标热度颜色：亮红/橙色 (255, 100, 50)
        // 这样看起来像烧红的铁
        r = r + (255 - r) * factor;
        g = g + (100 - g) * factor * 0.7; // 混合一点，保留原色特征
        b = b + (50 - b) * factor;
    }
    // 低温：低于 20 度开始变蓝/青，到 -50 度时达到最大冷度颜色
    else if (p.temperature < 20) {
        const maxCoolTemp = 70; // 20 到 -50 的温差
        const factor = Math.min(1, Math.abs(20 - p.temperature) / maxCoolTemp);
        
        // 目标冷度颜色：更鲜艳的冰蓝/白色 (180, 240, 255)
        // 增加混合权重，让颜色变化更明显
        r = r + (180 - r) * factor * 0.8;
        g = g + (240 - g) * factor * 0.8;
        b = b + (255 - b) * factor * 0.9;
    }

    return (Math.floor(r) << 16) | (Math.floor(g) << 8) | Math.floor(b);
}

export function updateBuffer(grid: Grid, buffer: Uint8Array) {
    const pixels = grid.pixels;
    const len = pixels.length;
    
    // 直接遍历
    for (let i = 0; i < len; i++) {
        const p = pixels[i];
        const idx = i * 4;
        if (p) {
            let c = p.color;
            let r = (c >> 16) & 0xFF;
            let g = (c >> 8) & 0xFF;
            let b = c & 0xFF;

            // 胶水效果：覆盖一层淡淡的青白色
            if (p.props.isGlued) {
                // 目标色：青白 (180, 255, 255)
                // 混合强度 0.3
                const glueFactor = 0.3;
                r = r + (180 - r) * glueFactor;
                g = g + (255 - g) * glueFactor;
                b = b + (255 - b) * glueFactor;
            }
            
            // 温度颜色混合逻辑
            // 高温：超过 200 度开始变红，到 800 度时达到最大热度颜色
            if (p.temperature > 200) {
                const maxHeatTemp = 600;
                const factor = Math.min(1, (p.temperature - 200) / maxHeatTemp);
                
                // 目标热度颜色：亮红/橙色 (255, 100, 50)
                // 这样看起来像烧红的铁
                r = r + (255 - r) * factor;
                g = g + (100 - g) * factor * 0.7; // 混合一点，保留原色特征
                b = b + (50 - b) * factor;
            }
            // 低温：低于 20 度开始变蓝/青，到 -50 度时达到最大冷度颜色
            else if (p.temperature < 20) {
                const maxCoolTemp = 70; // 20 到 -50 的温差
                const factor = Math.min(1, Math.abs(20 - p.temperature) / maxCoolTemp);
                
                // 目标冷度颜色：更鲜艳的冰蓝/白色 (180, 240, 255)
                // 增加混合权重，让颜色变化更明显
                r = r + (180 - r) * factor * 0.8;
                g = g + (240 - g) * factor * 0.8;
                b = b + (255 - b) * factor * 0.9;
            }

            buffer[idx] = r;
            buffer[idx + 1] = g;
            buffer[idx + 2] = b;
            buffer[idx + 3] = 255;
        } else {
            buffer[idx] = 0;
            buffer[idx+1] = 0;
            buffer[idx+2] = 0;
            buffer[idx+3] = 255; 
        }
    }
}
